import React from 'react';
import ReactDOM from 'react-dom/client'; // Importa createRoot desde 'react-dom/client'
import { ProjectProvider } from './ProjectContext';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root')); // Usa createRoot para crear un root

root.render(
  <React.StrictMode>
    <ProjectProvider>  {/* Envolver App con ProjectProvider */}
      <App />
    </ProjectProvider>
  </React.StrictMode>
);
